import { Col, Row } from "reactstrap";
import WizardPanel from "../WizardPanel";
import { PanelField, PanelSelectField } from "../panelFields";
import CountryLanguageTimezoneFields from "../shared/CountryLanguageTimezoneFields";

const SALE_TYPE_OPTIONS = [
  { value: "direct", label: "Direct" },
  { value: "indirect", label: "Indirect" },
];

/** @param {import("../WizardCard").StepPanelProps} props */
export default function CrmInfoPanel({ installation, setField, draftFields, setDraftField, status, bottomNav }) {
  const handleRegionChange = (patch) => {
    if ("country_code" in patch) setField("country_code", patch.country_code);
    if ("language_code" in patch) setField("language_code", patch.language_code);
    if ("timezone" in patch) setField("timezone", patch.timezone);
  };

  return (
    <WizardPanel
      title="CRM Information"
      subtitle="Information retrieved from Hubspot at installation creation"
      status={status}
      bottomNav={bottomNav}
    >
      <Row>
        <Col md={12}>
          <PanelField label="Client ID" value={installation?.location} mono readOnly />
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <PanelField label="Deal ID" value={installation?.deal_id} mono readOnly />
        </Col>
        <Col md={4}>
          <PanelField
            label="Client name"
            value={installation?.client_name}
            onChange={(v) => setField("client_name", v)}
          />
        </Col>
        <Col md={4}>
          <PanelField
            label="Client email"
            value={installation?.client_email}
            type="email"
            onChange={(v) => setField("client_email", v)}
          />
        </Col>
      </Row>

      <CountryLanguageTimezoneFields
        countryCode={installation?.country_code ?? ""}
        languageCode={installation?.language_code ?? ""}
        timezoneCode={installation?.timezone ?? ""}
        onChange={handleRegionChange}
      />

      <Row>
        <Col md={4}>
          <PanelField
            label="Camera count"
            value={installation?.camera_count}
            type="number"
            onChange={(v) => setField("camera_count", v === "" ? null : Number(v))}
          />
        </Col>
        <Col md={4}>
          <PanelSelectField
            label="Sale type"
            value={draftFields.sale_type ?? ""}
            onChange={(v) => setDraftField("sale_type", v)}
            options={SALE_TYPE_OPTIONS}
          />
        </Col>
        <Col md={4}>
          <PanelField
            label="Reseller"
            value={draftFields.reseller ?? ""}
            onChange={(v) => setDraftField("reseller", v)}
          />
        </Col>
      </Row>
    </WizardPanel>
  );
}
